import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OtpInput from "./OtpInput";
import ButtonLoading from "../general/ButtonLoading";
import moment from "moment";
import SendSMS from "./SendSMS";

function VerifyOTPForm({
  ftcLogo,
  errorStar,
  otpCode,
  handleOtpChange,
  handleResendOTP,
  isEmailExits,
  isResend,
  handleVerifyOtp,
  loading,
  isOtpExpiryExists,
  username
}) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!isOtpExpiryExists) return;

    const expiry = moment(isOtpExpiryExists);

    const interval = setInterval(() => {
      const now = moment();
      const duration = moment.duration(expiry.diff(now));

      if (duration.asSeconds() <= 0) {
        clearInterval(interval);
        setTimeLeft("Expired");
      } else {
        const minutes = String(duration.minutes()).padStart(2, "0");
        const seconds = String(duration.seconds()).padStart(2, "0");
        setTimeLeft(`${minutes}:${seconds}`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpExpiryExists]);

  return (
    <div className="login-form">
      <img src={ftcLogo} alt="FTC Logo" className="FTCLogo" />
      <h3>Verify OTP</h3>
      <form action="/">
        <OtpInput
          otp={otpCode}
          onOtpChange={handleOtpChange}
          errorMessage={errorStar}
        />
        <div className="form-group text-right">
          <div className="timer-text">
            {isEmailExits && !isResend ? (
              <>
                <div className="otp-sent-message">
                  {timeLeft === "Expired" ? (
                    <>OTP is <span className="text-danger">Expired</span> -  <Link onClick={handleResendOTP}><span className="text-success">Resend</span></Link></>
                  ) : (
                    <>OTP Expires In: {timeLeft}</>
                  )}
                </div>
              </>
            ) : isResend && isEmailExits ? (
              <div className="otp-sent-message">
                OTP Expires In: {timeLeft}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="form-group">
          <button className="button" onClick={handleVerifyOtp}>
            {loading && <ButtonLoading />} Verify
          </button>
        </div>
      </form>
      <SendSMS username={username} />
    </div>
  );
}

export default VerifyOTPForm;
